export default __webpack_public_path__ + "static/genti-ilustra-05d0643b0d4db015a8c6333d2295ce87.webp";